import { TXProductDetailsTemplate } from "../../../types/common/templates.types";

export const X_PRODUCT_DETAILS_TEMPLATE1: TXProductDetailsTemplate = {
  "Template avec Grille": {
    image:
      "https://firebasestorage.googleapis.com/v0/b/xoraia-prod.appspot.com/o/previews%2Fcontainers%2FXProductDetails%2FCapture%20d%E2%80%99e%CC%81cran%202022-11-19%20a%CC%80%2014.47.49.png?alt=media&token=d81a3f09-8120-4199-8d0c-43332da70f3b",
    template: [
      {
        name: "XProductDetails",
        props: {
          all: { padding: { Top: "20px", Bottom: "20px" } },
        },
      },
    ],
  },
};
